module.exports = __webpack_public_path__ + "static/media/statementsTransactions.8262f05e.svg";